import axios from "axios";
import { isPublicParishPath } from "../features/public-parish/paths";

const checkAuth = () => {
  /*  Getting token value stored in localstorage, if token is not present we will open login page 
    for all internal dashboard routes  */
  const TOKEN = localStorage.getItem("token");
  const PUBLIC_ROUTES = [
    "login",
    "forgot-password",
    "register",
    // R3 task 7 - FR-3.9a: the public application form and its /verify, /status sub-pages
    "apply",
    // R4 task 8 - FR-4.7: public certificate verification lookup. Was accidentally working
    // before this was added - nothing in checkAuth demands a token for the app to render since
    // the redirect only fires when the URL matches neither this list nor an existing token, but
    // that's incidental, not declared. Route this explicitly like every other public page.
    "certificates/verify",
  ];

  // Consent step A3: the consent page and its sub-pages (/consent/withdraw, A4) are for people with no account. Matched on
  // the path exactly, not with includes() on the href like the list above: the href carries the #token, and a substring
  // "consent" would also make /app/consent-texts look public.
  const isConsentPage = /^\/consent(\/|$)/.test(window.location.pathname)
    || (process.env.NODE_ENV === "development" && window.location.pathname === "/consent-preview");

  // Account package step 5: the set-password page, for someone who can't sign in yet - matched on the path, as above.
  const isSetPasswordPage = window.location.pathname === "/set-password";

  // Two-step sign-in (the account package plan, 6.5, 6.8): its setup link and the lock's link, for someone not signed in.
  const isSecondStepLinkPage = ["/second-step-setup", "/second-step-reopen"].includes(window.location.pathname);

  // The public pages (cmms public-page-plan.md, 2.2): the church's page, matched on the whole path, never a part of it.
  const isParishPage = isPublicParishPath(window.location.pathname);

  const isPublicPage = isConsentPage || isSetPasswordPage || isSecondStepLinkPage || isParishPage || PUBLIC_ROUTES.some((r) =>
    window.location.href.includes(r)
  );

  if (!TOKEN && !isPublicPage) {
    window.location.href = "/login";
    return;
  } else {
    if (TOKEN) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${TOKEN}`;
    }

    axios.interceptors.request.use(
      function (config) {
        // UPDATE: Add this code to show global loading indicator
        document.body.classList.add("loading-indicator");
        return config;
      },
      function (error) {
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      function (response) {
        // UPDATE: Add this code to hide global loading indicator
        document.body.classList.remove("loading-indicator");
        return response;
      },
      function (error) {
        document.body.classList.remove("loading-indicator");
        return Promise.reject(error);
      }
    );
    return TOKEN;
  }
};

export default checkAuth;
